<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box box-info">
          <form @submit.prevent class="form-horizontal">
            <input type="hidden" class="form-control" id="inputId" v-model="formData.id">
            <div class="box-body">
              <div class="box no-border">
                <div class="col-md-8">                    
                  <div class="form-group">
                    <label for="inputName">Role</label>
                    <select v-model="formData.roleId" class="form-control" :disabled="true">
                      <option v-for="(row, i) in listRole" v-bind:key="i" v-bind:value="row.id">
                        {{ row.name }}
                      </option>
                    </select>                       
                  </div>
                  <div class="form-group">
                    <label for="inputName">Authorization Object</label>
                    <select v-model="formData.authObjectId" class="form-control" :disabled="viewMode != MODE_CREATE">
                      <option v-for="(row, i) in listAuthObject" v-bind:key="i" v-bind:value="row.id">
                        {{ row.name }}
                      </option>
                    </select>                       
                  </div>                                                                                                        
                </div>
              </div>                          
            </div>
            <!-- /.box-body -->

            <div class="box no-border">
              <div class="box-header" style="height:40px;">
                <label>Authorization Fields:</label>          
                <div class="box-tools">              
                  <button @click="onCreateRoleAuthObjectField" class="btn btn-primary" v-if="viewMode != MODE_VIEW">Create</button>
                </div>
              </div>                              
              <div class="box-body no-padding table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th style="width:10px;text-align:right">#</th>
                      <th style="text-align:center;">Action</th>
                      <th style="text-align:left;">Name</th>                      
                      <th style="text-align:left;">Value</th>
                      <th style="text-align:left;">Description</th>                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in listAuthObjectField" v-bind:key="i">
                      <td class="text-nowrap" style="text-align:right;">{{ startSeqListAuthField + i + 1}}</td>
                      <td class="text-nowrap" style="text-align:center;">
                        <a href="#" v-on:click="onDisplayRoleAuthObjectField(row)" style="padding-right:5px">
                          <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                        </a>
                        <a href="#" v-on:click="onEditRoleAuthObjectField(row)" style="padding-right:5px" v-if="viewMode != MODE_VIEW">
                          <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                        </a>
                        <a href="#" v-on:click="onDeleteRoleAuthObjectField(row)" style="padding-right:5px" v-if="viewMode != MODE_VIEW">
                          <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                        </a>                                                                               
                      </td>
                      <td class="text-nowrap" style="text-align:left;">{{ row.authFieldName }}</td> 
                      <td class="text-nowrap" style="text-align:left;">{{ row.value }}</td>         
                      <td class="text-nowrap" style="text-align:left;">{{ row.authFieldDescription }}</td>                                               
                      <td hidden>{{ row.id }}</td>
                      <td hidden>{{ row.authObjectId }}</td>
                      <td hidden>{{ row.authFieldId }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                <button @click="onCancel()" class="btn btn-warning">Cancel</button>
                <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button>
              </div>
            </div>
            <!-- /.box-footer -->
          </form>
        </div>          
      </div>
    </div> 
  </div>  
</template>

<script>
import api from '../../api'
import SweetAlert from 'sweetalert2'

const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'

export default {
  name: 'RoleAuthObjectForm',
  data() {
    return {
      MODE_NONE: MODE_NONE,
      MODE_CREATE: MODE_CREATE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        roleId: 0,
        authObjectId: 0
      },
      listRole: null,
      listAuthObject: null,
      callback: undefined,
      listAuthObjectField: null,
      startSeqListAuthField: 0
    }
  },
  created() {
    if (this.$route.params) {
      this.callback = this.$route.params.callback
      this.formData.id = this.$route.params.id
      this.formData.roleId = this.$route.params.roleId
      this.viewMode = this.$route.params.mode
    }

    this.getDetail()
  },
  mounted() {
  },
  methods: {
    getDetail() {
      if (this.formData.id && this.formData.id !== 0) {
        api
          .request('Account', 'get', '/api/Role/GetDetailRoleAuthObject?Id=' + this.formData.id, null)
          .then(response => {
            var data = response.data
            this.formData = data.entity
          })
          .then(response => {
            this.getRole()
            this.getAuthObject()
            this.getAuthObjectField()
          })
          .catch(error => {
            var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
            SweetAlert.fire('Error', message, 'error')
          })
      } else {
        this.getRole()
        this.getAuthObject()
      }
    },
    getRole() {
      api
        .request('Account', 'get', '/api/Role/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listRole = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getAuthObject() {
      api
        .request('Account', 'get', '/api/Role/InquiryAllAuthObject', null)
        .then(response => {
          var data = response.data
          this.listAuthObject = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getAuthObjectField() {
      api
        .request('Account', 'get', '/api/Role/InquiryRoleAuthObjectFieldByRoleAuthObjectId?RoleAuthObjectId=' + this.formData.id, null)
        .then(response => {
          var data = response.data
          this.listAuthObjectField = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    initForm() {
      this.formData.id = 0
      this.formData.roleId = 0
      this.formData.authObjectId = 0
    },
    onCreate() {
      this.initForm()
      this.viewMode = MODE_CREATE
    },
    onEdit() {
      this.viewMode = MODE_UPDATE
    },
    onDisplay() {
      this.viewMode = MODE_VIEW
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      let name = this.callback[this.callback.length - 1].name
      let id = this.callback[this.callback.length - 1].id
      let mode = this.callback[this.callback.length - 1].mode
      this.callback.splice(this.callback.length - 1, 1)
      let params = {
        id: id,
        mode: mode,
        callback: this.callback
      }
      this.$router.push({ name: name, params: params })
    },
    onSave() {
      var data = {
        Id: this.formData.id,
        RoleId: this.formData.roleId,
        AuthObjectId: this.formData.authObjectId
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Account', 'post', '/api/Role/' + method + 'RoleAuthObject', data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.onDisplay()
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onCreateRoleAuthObjectField() {
      this.callback.push({
        id: this.formData.id,
        mode: this.viewMode,
        name: this.$route.name
      })
      let params = {
        id: 0,
        mode: MODE_CREATE,
        roleId: this.formData.roleId,
        roleAuthObjectId: this.formData.id,
        authObjectId: this.formData.authObjectId,
        callback: this.callback
      }
      this.$router.push({ name: 'Role AuthObjectField Form', params: params })
    },
    onDisplayRoleAuthObjectField(row) {
      this.callback.push({
        id: this.formData.id,
        mode: this.viewMode,
        name: this.$route.name
      })
      let params = {
        id: row.id,
        roleId: this.formData.roleId,
        mode: MODE_VIEW,
        callback: this.callback
      }
      this.$router.push({ name: 'Role AuthObjectField Form', params: params })
    },
    onEditRoleAuthObjectField(row) {
      this.callback.push({
        id: this.formData.id,
        mode: this.viewMode,
        name: this.$route.name
      })
      let params = {
        id: row.id,
        roleId: this.formData.roleId,
        mode: MODE_UPDATE,
        callback: this.callback
      }
      this.$router.push({ name: 'Role AuthObjectField Form', params: params })
    },
    onDeleteRoleAuthObjectField(row) {
      var data = {
        Id: row.id
      }
      var status = 'success'
      var message = ''
      api
        .request('Account', 'post', '/api/Role/DeleteRoleAuthObjectField', data)
        .then(response => {
          var resData = response.data

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.getDetail()
            if (this.viewMode === MODE_VIEW) {
              this.onDisplay()
            } else {
              this.onEdit()
            }
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}
</style>



// WEBPACK FOOTER //
// RoleAuthObjectForm.vue?c1126048